import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  UserOutlined,
  ShoppingCartOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { AutoComplete, Badge, Input } from "antd";
import { useEffect, useState } from "react";
import { getProducts as listProducts } from "../redux/actions/productActions";

const Navbar = ({ storeName }) => {
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart)?.cartItems;
  const getProducts = useSelector((state) => state.getProducts);
  const { products } = getProducts;

  const [options, setOptions] = useState([]);
  const [hide, setHide] = useState(false);
  const [offset, setOffset] = useState(0);
  const getCartCount = () => {
    return cart.length;
  };

  const storeCurrency = useSelector((state) => state.store)?.store?.storeInfo
    ?.currency;

  const searchResult = (text) =>
    products
      ?.filter((i) => i?.name?.toLowerCase().includes(text?.toLowerCase()))
      ?.map((product, index) => {
        return {
          label: (
            <div className="d-flex justify-content-between" key={index}>
              <Link to={`/product/${product?._id}`}>
                <span>{product?.name}</span>
              </Link>
            </div>
          ),
        };
      });

  const handleSearch = (value) => {
    setOptions(value ? searchResult(value) : []);
  };

  useEffect(() => {
    dispatch(listProducts());
  }, [dispatch]);

  useEffect(() => {
    const onScroll = () => setOffset(window.pageYOffset);
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className="sticky w-full z-20 top-0 left-0 bg-white">
      {offset <= 0 ? (
        <div className="bg-pink">
          <div className="container md:px-4 p-2 md:grid grid-cols-3 mx-auto">
            <Link to="/" className="flex justify-between items-center">
              <img
                src={
                  "https://cdn.shopify.com/s/files/1/0448/6476/6105/files/logo_300x300.png?v=1613748298"
                }
                className="w-40"
                alt={storeName}
              />
              <button
                onClick={() => (hide ? setHide(false) : setHide(true))}
                className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg md:hidden focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
              >
                <svg
                  className="w-6 h-6"
                  aria-hidden="true"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </Link>
            <div className="flex items-center my-2">
              <AutoComplete
                className="w-full"
                options={options}
                onSearch={handleSearch}
              >
                <Input
                  size="large"
                  placeholder="Search Products..."
                  prefix={<SearchOutlined />}
                />
              </AutoComplete>
            </div>
            <div className="flex items-center justify-center md:justify-end my-2 gap-10 md:order-2 full">
              <div className="m-0 text-black">
                {storeCurrency ? storeCurrency.substring(1) : storeCurrency}
              </div>
              <Link to="/cart">
                <Badge count={getCartCount()}>
                  <ShoppingCartOutlined className="text-base mr-2 hover:text-black" />
                </Badge>
              </Link>
              <Link
                to="/account"
                className="text-black flex flex-col hover:text-black"
              >
                <UserOutlined className="text-base" />
              </Link>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      <div
        className={`${
          hide ? "" : "hidden"
        }  justify-center items-center w-full md:flex md:w-auto md:order-1 bg-white`}
      >
        <ul className="flex gap-x-20 p-4 mb-0 items-center margin">
          <li className="p-2 md:py-0">
            <Link to="/" className="nav-item">
              Home
            </Link>
          </li>
          <li className="p-2 md:py-0">
            <Link to="/shop" className="nav-item">
              Products
            </Link>
          </li>
          <li className="p-2 md:py-0">
            <Link to="/contact" className="nav-item">
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
